<template>
    <!-- Hero Content -->
    <div
        class="slt-flex-center slt-gsap-about-top fixed top-0 h-screen w-full flex-col gap-8 overflow-hidden bg-base-silver pb-[5%] sm:h-screen lg:gap-12"
    >
        <AtomsH2 v-if="shouldRender(title)" class="relative z-10">
            <BaseFormatText2 ref="titleText" :text="title" type="span" />
        </AtomsH2>
        <AtomsArrowButton class="relative z-10" />

        <ClientOnly>
            <!-- Dynamic Lottie -->
            <LottieAnimation
                v-if="currentLottie"
                :key="screenSize"
                :loop="false"
                :autoplay="false"
                :pauseOnHidden="false"
                :animationData="currentLottie"
                class="absolute bottom-0 left-0 w-full"
                :class="{
                    'hidden lg:block bottom-[-7.5%]': screenSize === 'lg',
                    'hidden sm:block lg:hidden': screenSize === 'md',
                    'sm:hidden': screenSize === 'sm'
                }"
                ref="lottieRef"
            />
        </ClientOnly>
    </div>
</template>

<script setup>
import { shouldRender } from "~/lib/utils";
import { organismAboutHeroAnimate } from "@/lib/gsap-about";
import { textSplitAnimate, killAnimation } from "@/lib/gsap-core";
import { useResponsiveLottie } from "@/composables/useResponsiveLottie";

const { title } = defineProps({
    title: {
        type: [Array, String],
    },
});
const { isLoading } = useAppState();

const { current: currentLottie, load: loadLottie, screenSize } = useResponsiveLottie({
    sm: () => import("@/assets/lottie/about/hero/_M.json"),
    md: () => import("@/assets/lottie/about/hero/_P.json"),
    lg: () => import("@/assets/lottie/about/hero/_D.json"),
});

const lottieRef = ref(null);
const titleText = ref(null);

function playLottie() {
    setTimeout(() => {
        lottieRef.value?.play();
    }, 1500);
}

let tl = null;
onMounted(() => {
    loadLottie();
    tl = organismAboutHeroAnimate();
    watch(
        () => isLoading.value,
        (isCurrentlyLoading) => {
            if(!isCurrentlyLoading) playLottie();
            textSplitAnimate(isCurrentlyLoading, titleText);
        },
    );
});

onBeforeUnmount(() => {
    killAnimation(tl);
});
</script>
